export default __webpack_public_path__ + "static/media/user-group.6d3e4a9e.svg";